import { motion } from "framer-motion";
import { scrollTo } from "@/components/Reveal";

const links = [
  { label: "Manifesto", href: "#manifesto", testId: "nav-link-manifesto" },
  { label: "Results", href: "#results", testId: "nav-link-results" },
  { label: "Videos", href: "#videos", testId: "nav-link-videos" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 lg:px-10">
        <button
          onClick={() => scrollTo("#top")}
          data-testid="nav-logo"
          className="font-sans text-sm font-semibold uppercase tracking-[0.3em] text-white transition-opacity duration-300 hover:opacity-60"
        >
          Sergio Chavez
        </button>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              data-testid={l.testId}
              className="text-xs font-medium uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          onClick={() => scrollTo("#apply")}
          data-testid="nav-apply-btn"
          className="border border-white/30 px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white hover:text-black"
        >
          Apply Now
        </button>
      </div>
    </motion.header>
  );
}
